/**
 * DEV-329 — инициализация spec-chat в менеджерской зоне (userrequest, userorder).
 *
 * Чат живёт в popup, который открывается кликом по иконке облачка.
 * Используем СВОЙ модификатор `.spec-chat-anchor--open` вместо `.active`,
 * чтобы не конфликтовать со старым jQuery (`public/js/script_adm.js`),
 * который снимает `.active` по любому клику в документе.
 */

import { initSpecChat, openSpecChat, applyUnreadCounts } from './index.js';
import { apiRequest } from '../../api.js';

function pickProjectId() {
    const el = document.querySelector('[data-project-id]');
    if (el) return el.dataset.projectId;
    if (window.currentProjectId) return String(window.currentProjectId);
    return null;
}

function init() {
    if (!document.querySelector('.spec-chat-anchor')) return;
    const projectId = pickProjectId();
    if (!projectId) return;

    initSpecChat(projectId);

    document.addEventListener('click', (e) => {
        const handler = e.target.closest('[data-spec_comment_handler]');
        if (!handler) return;
        const anchor = handler.closest('.spec-chat-anchor');
        if (!anchor) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const specId = handler.dataset.specId;
        if (!specId) return;
        const isOpening = !anchor.classList.contains('spec-chat-anchor--open');

        // Закрыть остальные открытые anchor’ы (только в нашей менеджер-зоне).
        document.querySelectorAll('.spec-chat-anchor.spec-chat-anchor--open').forEach(el => {
            if (el !== anchor) el.classList.remove('spec-chat-anchor--open');
        });

        anchor.classList.toggle('spec-chat-anchor--open');
        if (isOpening) openSpecChat(specId);
    });

    // Клик вне popup закрывает все.
    document.addEventListener('click', (e) => {
        if (e.target.closest('.spec-chat-anchor')) return;
        document.querySelectorAll('.spec-chat-anchor.spec-chat-anchor--open')
            .forEach(el => el.classList.remove('spec-chat-anchor--open'));
    });

    refreshUnreadCounts(projectId);
    setInterval(() => refreshUnreadCounts(projectId), 30000);
}

async function refreshUnreadCounts(projectId) {
    try {
        const data = await apiRequest(`/project/${projectId}/spec-chat/unread-counts`);
        if (data?.success) applyUnreadCounts(data.counts || {}, data.has_messages || []);
    } catch (e) { /* polling — без шума */ }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
